import { Component } from 'react';
import * as React from 'react';
import { Grid } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import QuestionReviewComponent from './QuestionReviewComponent';

export default class ClusterQuestionReviewComponent extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showCommentsDialog: false,
        };

        this.updateQuestion = this.updateQuestion.bind(this);
        this.addQuestionComment = this.addQuestionComment.bind(this);
    }

    addQuestionComment(updateQuestionCommentData: any) {
        this.props.addQuestionComment(updateQuestionCommentData);
    }

    updateQuestion(updateQuestionData: any) {
        this.props.updateQuestion(updateQuestionData);
    }

    render() {
        return (
            <>
                {
                    this.props.cluster && !this.props.cluster.is_hidden ?
                        <>
                            {this.props.cluster.questions.length > 0 ?
                                <div key={'cluster-div' + this.props.clusterIndex} className="cluster">
                                    <Grid container={true} spacing={8}>
                                        <Grid xs={12} item={true}>
                                            <div className="pagePreviewClusterSection">
                                                <Grid container={true} spacing={24}>
                                                    <Grid item={true} xs={12}>
                                                        <div><h4>{this.props.cluster.title ? this.props.cluster.title.en : ''}</h4></div>
                                                        <div>
                                                            <p>
                                                                {this.props.cluster.cluster_description ? ReactHtmlParser(this.props.cluster.cluster_description.en) : ReactHtmlParser('')}
                                                            </p>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                            <div className="questions">
                                                {
                                                    this.props.cluster.questions.map((question: any, key: any) => {
                                                        return <QuestionReviewComponent
                                                            pages={this.props.pages}
                                                            pageNumber={this.props.pageNumber}
                                                            pagePreview={this.props.pagePreview}
                                                            updateQuestion={this.updateQuestion}
                                                            addQuestionComment={this.addQuestionComment}
                                                            clusterIndex={this.props.clusterIndex}
                                                            questionIndex={key}
                                                            questionId={question.question_id}
                                                            key={'question-component' + key}
                                                            question={question}
                                                            countryModuleSurveyMappingId={this.props.countryModuleSurveyMappingId}
                                                            moduleId={this.props.moduleId}
                                                            surveyStatus={this.props.surveyStatus}
                                                            isResponsePage={this.props.isResponsePage}
                                                            isOfflineMode={this.props.isOfflineMode}
                                                            userId={this.props.userId}
                                                            approveQuestion={this.props.approveQuestion}
                                                        />
                                                    })
                                                }
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                                :
                                ''
                            }
                        </>
                        :
                        ''
                }
            </>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/reviewquetions/ClusterQuestionReviewComponent.tsx